import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
  },

  '.dental-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* WpContent - style */
    '& .wp-content': {
      color: palette.text.secondary
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.header,

      '& .home-hero-pretitle': {
        paddingBottom: 32,
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '@media screen and (min-width: 1800px)': {
          maxHeight: '725px',
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        fontWeight: 'bold',
        color: palette.text.custom,
        '@media screen and (min-width: 1367px)': {
          fontSize: 66,
        },
      },
      '& .home-hero-subtitle': {
        '@media screen and (min-width: 1200px)': {
          paddingTop: 24,
          paddingBottom: 30,
        },
        '@media screen and (min-width: 1367px)': {
          fontSize: 20,
        },
        maxWidth: 490,
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .section-header__title': {
        color: palette.text.custom
      },
      '& .definition-service-title': {
        color: palette.text.custom
      },
      '& .benefits-wrapper': {
        padding: '0 10px',
        '& .section-header': {
          paddingBottom: 30,
        },
        '& .definition-service-description': {
          paddingBottom: 40,
        },
        '@media screen and (min-width: 1367px)': {
          '& .definition-service-title': {
            fontSize: 24,
            '& .definition-service-description': { 
              fontSize: 16
            }
          },
        },

        '& .image': {
          borderRadius: 32,
        },

        '& .definition-service-tile': {
          padding: '0px 14px',
        },
        '@media(min-width: 900px)': {
          '& .section-header': {
            paddingBottom: 50,
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.tableHead,
      },
      '& #pricing-benefit-section': {
        '& .section-header__title, .section-header__subtitle, .subscription-tabs-label, .summary-text, .summary-subtext':
          {
            color: palette.text.highlight,
          },
        '& .planCard': {
           border: 'none',
          '& .price-value': {
            fontSize: 40,
            color: palette.text.custom,
            fontWeight: 'bold !important'
          },
          '&:hover': {
            background: palette.text.highlight,
            color: palette.text.primary,
            '& .highlight-divider': {
              background: palette.divider,
            },
          },
          '& .customGetStarted': {
            backgroundColor: palette.background.primary,
            color: palette.text.highlight,
            borderColor: palette.background.primary
          },
          '& .MuiTypography-body2, .bold': {
            color: palette.text.secondary,
            fontSize: 15
          },
          '& .price-frequency, .display-frequency, .customSubscriberName': {
            color: palette.text.light
          },
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .MuiSwitch-thumb': {
            backgroundColor: palette.background.primary,
          },
          '& .MuiSwitch-track': {
            borderColor: palette.background.primary,
          },
          '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: palette.text.highlight,
            borderColor: palette.background.primary,
            '& .MuiSwitch-thumb': {
              borderColor: palette.background.primary,
              backgroundColor: palette.text.highlight,
            },
          },
          '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
            borderColor: palette.background.primary,
            backgroundColor: `${palette.background.primary} !important`,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      '& .section-header__title': {
        color: palette.text.custom
      },
      '& .step-title': {
        color:  palette.background.footer
      },
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-counter': {
        backgroundColor: palette.background.primary,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400,
        color: palette.text.light
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.light,
        fontSize: 20
      }
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.primary,
      },
      '& .stepperIconActive': {
        color: `${palette.background.primary} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.background.primary,
        '& .stepperIconText': {
          fill: palette.background.primary,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.background.primary,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        border: `1px solid ${palette.secondary.main}`,

        '& .savings-header': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        background: palette.background.primary,
      },
      '& .faq-contact-section': { 
        padding: 0
      }
    },
    '& .savings-topheader': {
      color: `${palette.text.highlight} !important`,
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .checkout-hero-section, & .faq-hero-section':
      {
        background: palette.background.header,
        '& .hero-header-title': {
          color: palette.text.custom,
          '@media screen and (min-width: 1200px)': { 
            fontSize: 48
          }
        },
        '& .hero-header-subtitle': {
          color: palette.text.secondary
        }
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.primary,
      },
      '& .hero-static-title, .hero-static-subtitle': {
        color: palette.text.highlight,
      },
      '& .hero-static-subtitle': {
        fontSize: 20
      },
      '& .primary-static-button': {
        border: 'none',
        color: palette.text.secondary,
        '&:hover': {
          border: 'none',
          background: palette.text.highlight,
          color: palette.primary.main,
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      '& .section-header__title': {
        color: palette.background.footer
      },
      background: palette.background.main,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '& .section-header__subtitle': {
          fontSize: 20
        },
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.background.arrow,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100,
          },
          '& .custom-avatar': {
            display: 'none',
          },
          '& .testimonial-content, .patient-label': {
            color: palette.text.secondary,
            fontSize: 18
          },
          '& .patient-label': {
            fontSize: 20
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '& .section-header__title-wrapper, .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& .hero-link-button': {
        '&:hover': {
          backgroundColor: palette.primary.main,
        },
      },
    },
    '& .accorion__item-title-container': {
      '& h3': {
        color: palette.text.secondary
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: 'rgba(71, 86, 112, 0.8)',
      },
      '& .faq-link': {
        fontWeight: 'normal',
      },
    },
    '& .faq-contact-wrapper': {
       background: palette.background.primary,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title': {
          fontSize: 25
        },
        '@media screen and (min-width: 1200px)': { 
          '& .contact-card-title': {
            fontSize: 56
          },
          '& .contact-card-subtitle': {
            fontSize: 20
          },
        },
        '& .contact-card-title, .contact-card-subtitle, .provider-contact-link, .provider-contact-details':
          {
            color: palette.text.highlight,
          },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.text.highlight,
          color: palette.text.primary,
          '& .highlight-divider': {
            background: palette.divider,
          },
        },
        '& .MuiTypography-body2, .bold': {
          color: palette.text.secondary
        },
        '& .price-value': {
          fontWeight: 'bold !important',
          color: palette.text.custom,
          fontSize: 40
        },
        '& .price-frequency, .display-frequency': {
          color: palette.text.light
        }
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .displayFlex': {
        '& .MuiTypography-body2, .bold': {
          color: `${palette.text.light} !important`
        },
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        color: palette.primary.main,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.background.primary,
      },
      '& .MuiSwitch-track': {
        borderColor: palette.background.primary,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked': {
        color: palette.text.highlight,
        borderColor: palette.background.primary,
        '& .MuiSwitch-thumb': {
          borderColor: palette.background.primary,
          backgroundColor: palette.text.highlight,
        },
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        borderColor: palette.background.primary,
        backgroundColor: `${palette.background.primary} !important`,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Footer Wrapper */
    '& .footer-wrapper, & .footer-wrapper a': {
      color: palette.text.highlight,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
  },
};